<script lang="ts">
	import { fade } from 'svelte/transition';
	import Success from '../Success.svelte';
	import InternalForm, {
		type NewsletterFormIntents,
		type NewsletterFormIntentsMap
	} from './InternalForm.svelte';
	import Oops from '$lib/assets/images/icons/404.svg?component';
	import { twMerge } from 'tailwind-merge';

	export let intent: NewsletterFormIntents = 'default';
	let className: string = '';
	export { className as class };

	let switchInfo = false;
	let error = false;

	function handleSwitchInfo(e: CustomEvent) {
		error = !e.detail?.ok || false;
		switchInfo = true;
	}

	const classMap: NewsletterFormIntentsMap<string> = {
		default: 'min-h-[800px] py-11 md:min-h-[580px] lg:min-h-[480px] overflow-y-visible',
		small: 'py-5 px-7 min-h-[600px] max-h-[600px] w-full overflow-y-auto'
	};

	const successTitleClassMap: NewsletterFormIntentsMap<string> = {
		default: '',
		small: 'text-3xl'
	};

	const successCaptionClassMap: NewsletterFormIntentsMap<string> = {
		default: '',
		small: 'text-sm'
	};
</script>

<section
	class={twMerge(
		'flex items-center justify-center bg-slate text-split',
		`${classMap[intent]} ${className}`
	)}
>
	<div
		class="grid grid-cols-1 items-center justify-center"
		class:container={intent === 'default'}
		class:mx-auto={intent === 'default'}
		style={intent === 'default' ? 'overflow: visible !important' : ''}
	>
		{#if !switchInfo}
			<div class="col-[1/2] row-[1/2]" transition:fade>
				<InternalForm {intent} on:switch-info={handleSwitchInfo} />
			</div>
		{:else if !error}
			<div class="col-[1/2] row-[1/2]">
				<Success
					class="static bg-opacity-0"
					successText="A sua subscrição foi confirmada. Prepare-se para dicas financeiras valiosas!"
				>
					<h2 slot="title" class="text-primary-light {successTitleClassMap[intent]}">
						Newsletter assinada!
					</h2>
					<h3 slot="caption" class="text-bland {successCaptionClassMap[intent]}" let:text>
						{text}
					</h3>
				</Success>
			</div>
		{:else}
			<div class="col-[1/2] row-[1/2]">
				<Success
					class="static items-center justify-center bg-opacity-0"
					successText="Não foi possível subscrever à newsletter neste momento. Tente novamente mais tarde."
				>
					<div slot="symbol">
						<Oops class="h-32" />
					</div>
					<h2 slot="title" class="text-primary-light {successTitleClassMap[intent]}">
						Ocorreu um erro...
					</h2>
					<h3 slot="caption" class="text-bland {successCaptionClassMap[intent]}" let:text>
						{text}
					</h3>
				</Success>
			</div>
		{/if}
	</div>
</section>
